import React from 'react';
import { InfoIcon } from './icons/InfoIcon';

// a notice's `screenOnlyText` ("this page updates by itself", "reload the page"), its link and its action button stay
// out of the PDF (SC-QA-72); its title still prints
export const Notices = ({ notices }) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {notices.map(notice => (
            <div className={`notice nt-${notice.tone}`} role="note" key={notice.title}>
                <InfoIcon />
                <div style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
                    <span className="nt-t">{notice.title}</span>
                    {notice.text && (
                        <span className={`nt-x${notice.screenOnlyText ? ' noprint' : ''}`}>{notice.text}</span>
                    )}
                    {notice.action && (
                        <button
                            type="button"
                            className="btn btn-secondary noprint"
                            onClick={notice.action.onClick}
                            style={{ alignSelf: 'flex-start', marginTop: 6 }}
                        >
                            {notice.action.label}
                        </button>
                    )}
                    {notice.link && (
                        <a
                            className="textlink noprint"
                            href={notice.href}
                            style={{ alignSelf: 'flex-start', padding: '4px 0' }}
                        >
                            {notice.link}
                        </a>
                    )}
                </div>
            </div>
        ))}
    </div>
);
